import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useBooxi } from '~/composables/_next/useBooxi';
import { useUser } from '~/composables/_next/useUser';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import useMenu from '~/composables/useMenu';
import useShippingCountry from '@/composables/useShippingCountry';
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenuItemGraphql',
  props: {
    item: null,
    canHaveExternalLinks: {
      default: function _default() {
        return false;
      }
    }
  },
  emits: ['click'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var route = useRoute();
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country;
    var _useBooxi = useBooxi(),
      loadBooxi = _useBooxi.loadBooxi,
      openBooxi = _useBooxi.openBooxi;
    var _useMenu = useMenu(),
      getMenuItemLink = _useMenu.getMenuItemLink;
    var _useWorkshop = useWorkshop(),
      checkAndAddWorkshopToCart = _useWorkshop.checkAndAddWorkshopToCart;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin,
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var items = computed(function () {
      var _props$item$subItemsC, _props$item, _props$item$subItemsC2;
      return (_props$item$subItemsC = (_props$item = props.item) === null || _props$item === void 0 ? void 0 : (_props$item$subItemsC2 = _props$item.subItemsCollection) === null || _props$item$subItemsC2 === void 0 ? void 0 : _props$item$subItemsC2.items) !== null && _props$item$subItemsC !== void 0 ? _props$item$subItemsC : [];
    });
    var isWishlistRedirect = computed(function () {
      var _props$item$url;
      return ((_props$item$url = props.item.url) === null || _props$item$url === void 0 ? void 0 : _props$item$url.includes('wishlist')) && !isAuthenticated.value;
    });
    var closeMenu = inject('close');
    function bookNow() {
      return _bookNow.apply(this, arguments);
    }
    function _bookNow() {
      _bookNow = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _route$query, _route$query2, _route$query3;
        var bookingFlow;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (closeMenu) {
                closeMenu();
              }
              _context2.next = 3;
              return loadBooxi();
            case 3:
              bookingFlow = 'locations';
              if (((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.isAccesOfAllShop) === 'false') bookingFlow = '';
              openBooxi({
                shopId: (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.shop,
                serviceTags: (_route$query3 = route.query) === null || _route$query3 === void 0 ? void 0 : _route$query3.serviceTags,
                bookingFlow: bookingFlow,
                onClose: function onClose(booxiData) {
                  if ((booxiData === null || booxiData === void 0 ? void 0 : booxiData.bookNowStatus) === 'Booked') {
                    doActionOrLogin({
                      previousRoutePath: route.path,
                      action: function () {
                        var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                          return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return checkAndAddWorkshopToCart(booxiData);
                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        function action() {
                          return _action.apply(this, arguments);
                        }
                        return action;
                      }()
                    });
                  }
                }
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _bookNow.apply(this, arguments);
    }
    var isExternalLink = computed(function () {
      return props.canHaveExternalLinks && itemUrl.value.startsWith('http');
    });
    var itemUrl = computed(function () {
      return getMenuItemLink(props.item);
    });
    var isLinkDisplayable = computed(function () {
      if (props.item.title && !props.item.isWorkShop) return true;
      if (props.item.isWorkShop && isSpecialShippingCountry.value) return true;
      return false;
    });
    var isSpecialShippingCountry = computed(function () {
      var _currentCountry$value;
      var countryCode = (_currentCountry$value = currentCountry.value) !== null && _currentCountry$value !== void 0 ? _currentCountry$value : '';
      return ['FR', 'BE'].includes(countryCode);
    });

    /**
     * Emits a 'click' event with the provided item.
     * @returns {void}
     */
    function emitClickEvent() {
      emit('click', props.item);
    }

    /**
     * Handles the click event based on item properties.
     * If the item is a workshop, triggers the booking process.
     * Otherwise, emits a click event if the items list is not empty.
     * @returns {void}
     */
    function handleClick() {
      return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
      _handleClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!props.item.isWorkShop) {
                _context3.next = 4;
                break;
              }
              bookNow();
              _context3.next = 10;
              break;
            case 4:
              if (!isWishlistRedirect.value) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return navigateToOrLogin({
                nextRoutePath: route.path,
                previousRoutePath: route.path
              });
            case 7:
              _context3.next = 10;
              break;
            case 9:
              if (items.value.length > 0) {
                emitClickEvent();
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _handleClick.apply(this, arguments);
    }
    return {
      __sfc: true,
      route: route,
      props: props,
      currentCountry: currentCountry,
      loadBooxi: loadBooxi,
      openBooxi: openBooxi,
      getMenuItemLink: getMenuItemLink,
      checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
      doActionOrLogin: doActionOrLogin,
      navigateToOrLogin: navigateToOrLogin,
      isAuthenticated: isAuthenticated,
      items: items,
      isWishlistRedirect: isWishlistRedirect,
      emit: emit,
      closeMenu: closeMenu,
      bookNow: bookNow,
      isExternalLink: isExternalLink,
      itemUrl: itemUrl,
      isLinkDisplayable: isLinkDisplayable,
      isSpecialShippingCountry: isSpecialShippingCountry,
      emitClickEvent: emitClickEvent,
      handleClick: handleClick,
      NuxtLinkCustom: NuxtLinkCustom,
      AzImg: AzImg,
      AzIcon: AzIcon
    };
  }
});